import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';

@Component({
  selector: 'app-auth-redirection',
  templateUrl: './auth-redirection.component.html',
  styleUrls: ['./auth-redirection.component.scss']
})
export class AuthRedirectionComponent implements OnInit {

  message: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private keycloakService: KeycloakService
  ) {
  }

  ngOnInit() {
    if (this.keycloakService.getUserRoles().includes(Role.Orders)) {
      this.router.navigate(['/provision/orders/search']);
    } else if (this.keycloakService.getUserRoles().includes(Role.Tasks)) {
      this.router.navigate(['/provision/tasks/search']);
    } else if (this.keycloakService.getUserRoles().includes(Role.Products)) {
      this.router.navigate(['/provision/products/search/']);
    } else if (this.keycloakService.getUserRoles().includes(Role.Catalog)) {
      this.router.navigate(['/provision/catalog']);
    } else if (
      this.keycloakService.getUserRoles().includes(Role.CatalogManagement)
      ||
      this.keycloakService.getUserRoles().includes(Role.Templates)
      ||
      this.keycloakService.getUserRoles().includes(Role.Coverage)
      ||
      this.keycloakService.getUserRoles().includes(Role.FtthLoad)
      ||
      this.keycloakService.getUserRoles().includes(Role.TaskManagement)
      ||
      this.keycloakService.getUserRoles().includes(Role.MasterData)
      ||
      this.keycloakService.getUserRoles().includes(Role.PortOut)
    ) {
      this.router.navigate(['/provision/management/']);
    } else if (this.keycloakService.getUserRoles().includes(Role.Resources)) {
      this.router.navigate(['/provision/resources/']);
    } else {
      this.router.navigate(['/', '403']);
    }
    this.router.navigate(['/provision/orders/search']);
  }




}
